export const environment = {
  production: false,
  authServiceUrl: 'https://borgo-kyc-admin-test.internal.sparbankensyd.se/service',
  kycApiUrl: 'https://borgo-kyc-admin-test.internal.sparbankensyd.se/api',
  domain: 'borgo-kyc-stage.internal.sparbankensyd.se', // We use real BankId on test
  testMode: true
}
